import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import OrganizationSelector from './OrganizationSelector';

const OrganizationChecker = ({ children }) => {
  const { currentUser, selectOrganization } = useAuth();
  const [showSelector, setShowSelector] = useState(false);

  useEffect(() => {
    // Verificar se o usuário precisa selecionar uma organização
    if (
      currentUser &&
      currentUser.organizationIds &&
      currentUser.organizationIds.length > 0 &&
      !currentUser.currentOrganization
    ) {
      setShowSelector(true);
    }
  }, [currentUser]);

  return (
    <>
      {children}
      <OrganizationSelector
        open={showSelector}
        onSelect={organizacao => {
          selectOrganization(organizacao);
          setShowSelector(false);
        }}
        onClose={() => setShowSelector(false)}
      />
    </>
  );
};

export default OrganizationChecker;
